"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@completeanatomy/ui");
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
const LabelItemWrapper_1 = require("../LabelItemWrapper");
const LabelItemDefault = ({ identifier, title, subtitle, selectedLabelID, onSelectLabelID, onClickInfo, }) => {
    const isSelected = identifier === selectedLabelID;
    const onItemClick = (0, react_1.useCallback)(() => {
        onSelectLabelID(identifier);
    }, [identifier, onSelectLabelID]);
    const onInfoClick = (0, react_1.useCallback)((e) => {
        e.stopPropagation();
        onClickInfo(identifier);
    }, [identifier, onClickInfo]);
    return ((0, jsx_runtime_1.jsxs)(LabelItemWrapper_1.LabelItemWrapper, { isSelected: isSelected, onClick: onItemClick, "data-e2e": 'LabelItemWrapper', children: [(0, jsx_runtime_1.jsxs)(Names, { "data-e2e": 'Names', children: [(0, jsx_runtime_1.jsx)(PrimaryName, { isSelected: isSelected, "data-e2e": 'PrimaryName', children: title }), (0, jsx_runtime_1.jsxs)(LatinName, { "data-e2e": 'LatinName', children: ["(", subtitle, ")"] })] }), (0, jsx_runtime_1.jsx)(StyledToolBarBaseButton, { onClick: onInfoClick, isVisible: isSelected, "data-e2e": 'StyledToolBarBaseButton', children: (0, jsx_runtime_1.jsx)(ui_1.Icon, { name: ui_1.Icons.Info_Bold, width: 24, height: 24, "data-e2e": 'Icon' }) })] }, `${identifier}-${selectedLabelID}`));
};
exports.default = (0, react_1.memo)(LabelItemDefault);
const PrimaryName = styled_components_1.default.div `
  line-height: 24px;
  font-weight: ${({ isSelected }) => (isSelected ? 700 : 400)};
`;
const LatinName = styled_components_1.default.div `
  font-size: 16px;
  line-height: 18.32px;
  margin: 8px 0 0;
`;
const Names = styled_components_1.default.div `
  padding: 0 8px;
`;
const StyledToolBarBaseButton = (0, styled_components_1.default)(ui_1.ToolBarBaseButton) `
  pointer-events: none;
  opacity: 0;
  visibility: hidden;

  ${({ isVisible }) => isVisible &&
    (0, styled_components_1.css) `
      pointer-events: auto;
      opacity: 1;
      visibility: visible;
    `}
`;
